export const UPLOAD_METADATA_SUCESS = 'UPLOAD_METADATA_SUCESS';
export const UPLOAD_METADATA_FAILURE = 'UPLOAD_METADATA_FAILURE';

export const IMPORT_SUMMARY_SUCESS = 'IMPORT_SUMMARY_SUCESS';
export const IMPORT_SUMMARY_FAILURE = 'IMPORT_SUMMARY_FAILURE';
